import { BookingCreatorPanelType } from 'external-services/booking-validation-service/bookingValidation.types';
import { IScrollPositionState } from './types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const NS = 'scrollPositionSlice';

const initialState: IScrollPositionState = {
  scrollItems: [],
  validationErrorPanels: [],
};

const scrollPositionSlice = createSlice({
  name: 'scrollPosition', // used in action types
  initialState,
  reducers: {
    setScrollItems: (state: IScrollPositionState, action: PayloadAction<BookingCreatorPanelType[]>) => {
      state.scrollItems = action.payload;
    },
    setValidationErrorPanels: (state: IScrollPositionState, action: PayloadAction<BookingCreatorPanelType[]>) => {
      state.validationErrorPanels = action.payload;
    },
    pushToFrontOfScrollItems: (state: IScrollPositionState, action: PayloadAction<BookingCreatorPanelType>) => {
      state.scrollItems = [action.payload, ...state.scrollItems];
    },
  },
  extraReducers: (builder) => {
    // builder
    //   .addCase(loadTags.pending, (state, action) => {
    //     state.status = FetchingStatus.loading;
    //   })
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = scrollPositionSlice;
// Extract and export each action creator by name
export { actions as scrollPositionActions };
// Export the reducer, either as a default or named export
export default reducer;
